
const AJADev = process.env.NODE_ENV==='development' && process.env.VUE_APP_AGENCY==='AJA' 
// const AJADev = true
import * as mock from '../mock';

export const getConditionMeesage = async () => {
    if(AJADev) {
        return mock.ConditionMeesage
    }
}

export const getConditionMeesageDetail = async (id) => {
    if(AJADev) {
        return mock.ConditionMeesageDetail
    }
}

export const getMessageDataByID = async (message_id) => {
    if(AJADev) {
        return mock.MessageData
    }
}

export const getUnitCondition = async () => {
    if(AJADev) {
        return mock.UnitCondition
    }
}

export const getClientType = async () => {
    if(AJADev) {
        return mock.ClientType
    }
}

export const queryInsuranceByClient = async () => {
    if(AJADev) {
        return mock.InsuranceType
    }
}